import { Contract } from '@/modules/Contract/types'
import dayjs from 'dayjs'
import { useEffect } from 'react'
import { Control, Path, useWatch } from 'react-hook-form'

interface useCommitmentTimeProps {
    index: number
    name: string
    setValue: (key: Path<Contract>, value: any) => void
    control: Control<Contract>
}

const useCommitmentTime = ({
    name,
    control,
    index,
    setValue,
}: useCommitmentTimeProps) => {
    const commitment_time = useWatch({
        control,
        name: `${name}.[${index}].commitment_time` as Path<Contract>,
    })

    const today = dayjs()

    useEffect(() => {
        setValue(
            `${name}.[${index}].commitment_startdate` as Path<Contract>,
            commitment_time ? today : null
        )
        setValue(
            `${name}.[${index}].commitment_enddate` as Path<Contract>,
            commitment_time ? today.add(commitment_time, 'month') : null
        )
    }, [commitment_time])
}

export default useCommitmentTime
